<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Approve/Unapprove Question Bank</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br>
       <v-row justify="center" dense>
                <v-col cols="12" sm="3" md="3">
              <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  clearable
                  required
                  v-model="sel_crs"
                  return-object
                  :items="inst_crs_list"
                  item-text="coi_display_name"
                  label="Select Subject"
                  outlined
                  persistent-hint
                  @change="getChapters()"
                  hint="Select Subject"
              >
              </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" v-if="chapters_list!=''">
                <v-autocomplete color="#0F2027" dense rounded required v-model="chapter" :items="chapters_list" item-text="name" item-value="id" label="Chapter" outlined persistent-hint hint="Please Select Chapter" multiple />
          </v-col>
             <v-col cols="12" sm="3" md="3" v-if="quiztype_list!=''">
                <v-autocomplete color="#0F2027" dense rounded required v-model="quiztype" :items="quiztype_list" item-text="name" item-value="id" label="Quiz Type" outlined persistent-hint hint="Please Select Quiz Type" multiple />
            </v-col>
            <v-col cols="12" sm="1" md="1" align="center">
                <v-btn class="button" @click="fetchQuestions()" :loading="loader">Fetch</v-btn>
            </v-col>
            </v-row>
       </v-card>

     <v-card class="box" v-if="question_list!=''">
                  <v-data-table :headers="headers" :items="question_list" show-select :search="search" class="elevation-1 mytable" v-model="selected" item-key="id" :items-per-page="-1" fixed-header height="600px">
                  <template v-slot:[`item.question`]="{ item }">
                      <span v-html="item.question"> </span>
                  </template>
                  <template v-slot:[`item.filepath`]="{ item }">
                      <v-btn icon @click="viewQuizQuestion(item)"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                  </template>
                   <template v-slot:[`item.isapproved`]="{ item }">
                        <span v-if="item.isapproved">
                            <v-icon class="mr-2 v-icon-size" color="success"
                            >mdi-check-circle-outline</v-icon
                            >
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error"
                            >mdi-close-circle-outline</v-icon
                            >
                        </span>
                        </template>
                  <template v-slot:top class="pb-5">
                      <v-row>
                          <v-col cols="12" md="4" sm="4">
                              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                          </v-col>
                      </v-row>
                  </template>
              </v-data-table>
               <center v-if="this.selected.length > 0">
                    <v-btn class="button" color="orange" v-if="selected != ''" :loading="loader"  @click="approveQuestionBank(true)">Approve Questions</v-btn>
                    <v-btn class="button" color="red" v-if="selected != ''" :loading="loader"  @click="approveQuestionBank(false)">Unapprove Questions</v-btn>
                </center>

                <v-row justify="center" dense v-if="this.selected.length > 0">
                  <strong>Total Selected - {{ selected.length }}</strong>
              </v-row>

 </v-card>

 <v-row justify="center">
              <v-dialog v-model="dialog_view_mcq" persistent max-width="800px">
                  <v-card>
                      <v-toolbar class="toolbar" flat dense>
                          <v-toolbar-title>
                              <h6>
                                  <strong> MCQ Question </strong>
                              </h6>
                          </v-toolbar-title>
                      </v-toolbar>

                      <br />
                      <!-- {{view_question_list}} -->
                      <v-card-text>
                          <v-container>
                              <v-card class="box">
                                  <v-row justify="center">
                                      <span class="text1">
                                          <strong> Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                                      </span>
                                      <v-col cols="12" sm="12" md="12">
                                          <center>
                                              <span class="text1"> <strong> Problem Statement</strong></span>
                                          </center>
                                      </v-col>
                                  </v-row>

                                  <span v-if="view_question_list.filepath != null">
                                      <span class="span-mr" v-if="view_question_list.quizQuestion_text" v-html="view_question_list.quizQuestion_text"> </span>
                                      <v-dialog v-model="dialog_view_img" max-width="500px">
                                          <template v-slot:activator="{ on }">
                                              <v-icon color="black" @click="dialog_view_img=true">mdi-eye</v-icon>
                                          </template>
                                          <v-card>
                                              <v-toolbar class="toolbar" flat dense>
                                                  <v-toolbar-title>
                                                      <h6>
                                                          <strong> Images </strong>
                                                      </h6>
                                                  </v-toolbar-title>
                                              </v-toolbar>
                                              <br />
                                              <v-card-text>
                                                  <center>
                                                      <img :src="basepath + view_question_list.filepath" style="border: 3px solid black;" alt="Image" width="200px" height="200px" />
                                                  </center>
                                              </v-card-text>
                                              <v-card-actions>
                                                  <v-btn color="error" class="justify-center" rounded @click="dialog_view_img = false">Close</v-btn>
                                              </v-card-actions>
                                          </v-card>
                                      </v-dialog>
                                  </span>
                                  <span v-else v-html="view_question_list.quizQuestion_text"> </span>
                                  <v-col cols="12" sm="12" md="12">
                                      <center>
                                          <span class="text1"> <strong>Options</strong></span>
                                      </center>
                                  </v-col>
                                  <span v-for="option in view_question_list.option_list" :key="option.op_id">
                                    <v-row align="center">
                                                <v-col cols="1">
                                                     <input class="radiospace" type="radio" v-if="option.iscorrect" :checked="option.op_id" />
                                                     <input type="radio" name="opt" class="radiospace" v-else v-model="option.op_id" disabled />
                                                 </v-col>

                                            <!-- Column for options -->
                                                <v-col cols="9">
                                                    <div style="display: flex; align-items: center;">
                                                     <span class="span-mr" v-if="option.mcq_option_file_path == null" v-html="option.option_value"></span>
                                                    <span v-else>
                                                    <span class="span-mr" v-if="option.option_value" v-html="option.option_value"></span>
                                                    </span>
                                                    </div>
                                                 </v-col>

                                            <!-- Column for eye icon -->
                                                <v-col cols="2">
                                                    <a :href="basepath + option.mcq_option_file_path + option.mcq_filename" target="blank" class="p-2">
                                                    <v-icon color="black">mdi-eye</v-icon>
                                                    </a>
                                                </v-col>
                                            </v-row>
                                  </span>
                              </v-card>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-row>
                              <v-btn color="error" class="justify-center" rounded @click="dialog_view_mcq = false">Close</v-btn>
                          </v-row>
                        <br/>
                        <br/>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
          </v-row>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
         dialog_view_mcq: false,
        search:"",
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
       headers: [
            //   { text: "Sr No", value: "srno" },
              { text: "Quiz Type", value: "quiztype" },
              { text: "Question", value: "question" },
              { text: "chapter", value: "chapter" },
              { text: "Marks", value: "marks" },
              { text: "Difficulty Level", value: "quizquestiondifficultylevel" },
              { text: "Is Approved", value: "isapproved" },
              { text: "View", value: "filepath" },
          ],
      inst_crs_list:[],sel_crs:"",chapters_list:[],quiztype_list:[],chapter:[],quiztype:[],question_list:[],
       selected: [],
          total_selected: [],view_question_list: [], basepath: null,selected_questions:[]
  }),
   methods: {
    async approveQuestionBank(flag) {
            if (!confirm("Are You Sure You Want To Approve...?")) return;
              const formData = {
                   selected_questions: [],
                   status:flag
              };
               var index = 0;
                this.selected.forEach(function (item) {
                    formData.selected_questions[index] = item.id;
                    index++;
                });
              this.loader=true
              axios
                 try {
          const res = await axios.post("/LiveClass/approveQuestionBank", formData);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Approved/Unapproved Successfully.."); // show snackbar
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                // this.getLessonPlan();
                // this.lesson_no = res.data.lesson_plan;
                 this.loader=false
      }
          },
     async viewQuizQuestion(item) {
              const data = {
                  qid: item.id,
                  from: "View_Bank",
              };
              try {
                  const res = await axios.post("/LiveClass/viewQuestion", data);
                  if (res.data.flag == "YES") {
                      if (res.data.quiztype == "MCQ") {
                          this.dialog_view_mcq = true;
                          this.view_question_list = res.data.questions[0];
                      }
                    //   if (res.data.quiztype == "MultiWordAnswer") {
                    //       this.dialog_view_mwa = true;
                    //       this.view_question_list = res.data.questions[0];
                    //   }
                    //   if (res.data.quiztype == "SWA") {
                    //       this.dialog_view_swa = true;
                    //       this.view_question_list = res.data.questions[0];
                    //   }
                    //   if (res.data.quiztype == "MTP") {
                    //       this.dialog_view_mtp = true;
                    //       this.view_question_list = res.data.questions[0];
                    //   }
                    //   if (res.data.quiztype == "SUBJECTIVE") {
                    //       this.dialog_view_subj = true;
                    //       this.view_question_list = res.data.questions[0];
                    //   }
                    //   if (res.data.quiztype == "TrueFalse") {
                    //       this.dialog_view_tof = true;
                    //       this.view_question_list = res.data.questions[0];
                    //   }
                  }
                  if (res.data.flag == "No") {
                      this.showSnackbar("red", res.data.snackbar); // show snackbar
                  }
              } catch (error) {
                  this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              } finally {
              }
          },
    async fetchQuestions(){
         try {
        const formData = {
          coff_id: this.sel_crs.coff_id,
          chapter: this.chapter,
          quiztype: this.quiztype,
        };
          const res = await axios.post("/LiveClass/fetchQuestions",formData);
          if (res.data.flag == "YES") {
            this.question_list=res.data.question_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }

    },
    async getChapters(){
         try {
        const formData = {
          coff_id: this.sel_crs.coff_id,
        };
          const res = await axios.post("/LiveClass/getCourseChapters",formData);
          if (res.data.flag == "YES") {
            this.chapters_list=res.data.chapters_list
            this.quiztype_list=res.data.quiztype_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }

    },
    async questionBankHome(item) {
      try {
          const res = await axios.post("/LiveClass/questionBankHome");
          if (res.data.flag == "YES") {
            this.inst_crs_list=res.data.inst_crs_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.questionBankHome();
    this.basepath = localStorage.getItem("awspath");
  },
  watch: {},
    // computed: {
    //       bookList1() {
    //           return this.question_list.filter((d) => {
    //               return Object.keys(this.filters).every((f) => {
    //                   return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //               });
    //           });
    //       },
    //   },
};
</script>
<style scoped>
</style>